module.exports = __webpack_public_path__ + "static/media/hero-3.96eccc95.png";